import type { InquiryEntity } from "../model";

import { Tk } from "~/shared/i18n";

const TK_BY_INQUIRY_SUBJECT: Record<InquiryEntity.SubjectSchema, Tk> = {
  I_D_LIKE_TO_ORDER: Tk.I_D_LIKE_TO_ORDER,
  SERVICE_QUESTIONS: Tk.QUESTIONS_ABOUT_SERVICES,
  OTHER: Tk.OTHER,
};

export { TK_BY_INQUIRY_SUBJECT };
